<!-- Copyright (c) 2023 Cigent Technology Inc. All Rights Reserved. -->
<ng-container *ngIf="securityLockEngaged$ | async">
    <div id="priorityLockBanner" class="banner" >
        {{'priority_lock.priority_lock_banner' | translate }}
    </div>
</ng-container>
